import { Controller } from "@hotwired/stimulus"

// Lets someone check several rows (goals, for now — see
// games/_sumula_goals.html.erb) and submit them all for deletion in one
// request, instead of clicking "Desfazer" once per row (e.g. after an
// accidental double-tap logged the same scorer ten times). Every checkbox
// is associated with a single shared <form> elsewhere in the document via
// the HTML `form="..."` attribute, so the actual submission is a plain
// native form — this controller only toggles the "select all" checkbox and
// shows/hides the bulk-action bar with a live count.
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bar", "count"]

  connect() {
    this.updateBar()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.selectAllTarget.checked })
    this.updateBar()
  }

  toggle() {
    this.updateBar()
  }

  updateBar() {
    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked)

    if (this.hasCountTarget) this.countTarget.textContent = checked.length

    if (this.hasBarTarget) {
      this.barTarget.classList.toggle("hidden", checked.length === 0)
      this.barTarget.classList.toggle("flex", checked.length > 0)
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked.length > 0 && checked.length === this.checkboxTargets.length
      this.selectAllTarget.indeterminate = checked.length > 0 && checked.length < this.checkboxTargets.length
    }
  }
}
